import * as React from 'react';

interface IResultsCard {
  url: string;
  heading: string;
  tags: Array<string>;
}

const ResultsCard: React.FC<IResultsCard> = ({ url, heading, tags }) => {
  return (
    <a href={url} className="release-card">
      <h3 className="release-card__heading">{heading}</h3>
      <p className="release-card__description">{tags.join(', ')}</p>
    </a>
  );
};

export default ResultsCard;
